import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Link as ExternalLink } from '@chakra-ui/react';

import Callout from 'components/_core/Callout';
import useGetMigrationToEpData from 'features/Bank/pages/Overview/Transactions/hooks/useGetMigrationToEPData';

import { DetailedTransactionFragment } from '../graphql/fragment/detailedTransaction.gql';
import {
  getWarningsByTransactionType,
  isDirectDebit,
  isTransactionTypeValidToBeTaggued,
} from './utils';

const UPDATE_DIRECT_DEBIT_MANDATE_HELP_URL =
  'https://help.shine.fr/fr/articles/6309428-comment-modifier-mes-coordonnees-bancaires-pour-mes-prelevements';

const OldIbanWarning: FC<{ transaction: DetailedTransactionFragment }> = ({
  transaction,
}) => {
  const {
    error,
    hasBeenMigratedToEP,
    hasBeenSevenDaysSinceMigrationStarted,
    loading,
    migratedToEPAt,
  } = useGetMigrationToEpData();

  if (loading || error !== undefined) {
    return null;
  }

  const warningText = getWarningsByTransactionType({
    migratedToEPAt,
    transaction,
  });

  if (
    hasBeenMigratedToEP &&
    hasBeenSevenDaysSinceMigrationStarted &&
    transaction.isOnAgentWallet &&
    warningText !== null &&
    isTransactionTypeValidToBeTaggued(transaction)
  ) {
    if (isDirectDebit(transaction)) {
      return (
        <ExternalLink href={UPDATE_DIRECT_DEBIT_MANDATE_HELP_URL} isExternal>
          <Callout marginX="space-16" variant="warning">
            <Callout.Content>{warningText}</Callout.Content>
          </Callout>
        </ExternalLink>
      );
    }

    return (
      <Link to="info">
        <Callout marginBottom="space-16" marginX="space-16" variant="warning">
          <Callout.Content>{warningText}</Callout.Content>
        </Callout>
      </Link>
    );
  }

  return null;
};

export default OldIbanWarning;
